/**
 * modalSeasonal
 */

// Module dependencies
import 'protons';

// Module styles
import './_modal-seasonal.scss';

// Module template
import './_modal-seasonal.twig';

export const name = 'modalSeasonal';

export const defaults = {
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */

export function enable($context, { modalSeasonal = {} }) {
  const node = $('.lightbox-donation-form', $context);
  const form = $('form', $context);
  const submitButton = $('.oxfam-button__arrow', node);

  submitButton.data('form', form);

  submitButton.click(function(event) {
    event.preventDefault();

    const submissionUrl = this.closest("[data-submission-url]").dataset.submissionUrl;

    const form = $(this).data('form');

    var targetUrl = new URL(submissionUrl);
    // Preserve query params, if any.
    const targetSearch = new URLSearchParams(targetUrl.search);

    const sourceSearch = new URLSearchParams(window.location.search);
    const sourceParam = sourceSearch.get('source');
    if (sourceParam !== null) targetSearch.append('source', sourceParam);

    var donationAmount = $('#lightbox-donation-amount', form).val();
    targetSearch.append('transaction.donationAmt', donationAmount);

    var href = `${targetUrl.origin}${targetUrl.pathname}?${targetSearch.toString()}`;
    window.location.href = href;
  })
}

export default enable;
